import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IAbstractView, ILanguageObject } from '@core/interfaces';
import { SuggestionsPresenter } from './singleproduct-suggestions.presenter';
import { ISuggestionsComponent } from './interfaces';
import { Observable, of } from 'rxjs';
import { MenuItem, Price, ProductChannel } from '@/core/models';

@Component({
  selector: 'app-singleproduct-suggestions',
  templateUrl: './singleproduct-suggestions.component.html',
  styleUrls: ['./singleproduct-suggestions.component.scss'],
  standalone: false,
  providers: [SuggestionsPresenter]
})
export class SuggestionsComponent 
  extends IAbstractView<SuggestionsPresenter> 
  implements ISuggestionsComponent 
{
  @Input() translations: ILanguageObject = {} as ILanguageObject;
  @Input() suggestionItems$: Observable<MenuItem[]> = of([]);
  @Input() decimalPrecision: string = '';
  @Output() addSuggestionItem = new EventEmitter<MenuItem>();

	no_image: string = 'assets/plato-no-image.svg';

  constructor(presenter: SuggestionsPresenter) {
    super(presenter);
  }

  productChannel<T extends keyof ProductChannel>(article: MenuItem, key: T): ProductChannel[T] | null {
    return this.presenter.productChannel(article, key);
  }

  productChannelPrice<T extends keyof Price>(article: MenuItem, key: T): Price[T] | null {
    return this.presenter.productChannelPrice(article, key);
  }

  hasSuggestionItems(items: MenuItem[] | null): boolean {
    return this.presenter.hasSuggestionItems(items);
  }

  isSuggestedItemOutOfStock(article: MenuItem): boolean {
    return this.presenter.isSuggestedItemOutOfStock(article);
  }

  onAddSuggestionItem(article: MenuItem): void {
    this.addSuggestionItem.emit(article);
  }
}
